// Story prompts and bonus page prompts

export const MEMORY_PROMPTS = [
  { cat: 'Recipes & Traditions', prompts: [
    { title: 'A Favorite Family Recipe', hint: 'The dish everyone asks for, and the story behind it' },
    { title: 'Family Traditions', hint: 'Something your family always did together' },
    { title: 'Holiday Traditions', hint: 'The foods, songs, or rituals that made it special' },
    { title: 'Where We Come From', hint: 'Your family\u2019s roots and heritage' },
  ]},
  { cat: 'Poems, Quotes & Letters', prompts: [
    { title: 'A Poem I Love', hint: 'Copy or write a poem that means something to you' },
    { title: 'Words I Want You to Remember', hint: 'A quote, verse, or saying that guides you' },
    { title: 'A Letter to My Grandchildren', hint: 'What you want them to know' },
    { title: 'A Prayer or Blessing', hint: 'Something you\u2019d want read at a family gathering' },
  ]},
  { cat: 'Life Wisdom', prompts: [
    { title: 'The Best Advice I Ever Received', hint: 'Who said it, and how it shaped you' },
    { title: 'What I\u2019ve Learned About Love', hint: 'In your own words' },
    { title: 'If I Could Do It All Again', hint: 'What you\u2019d keep and what you\u2019d change' },
    { title: 'Things That Make Me Laugh', hint: 'The sillier the better' },
  ]},
  { cat: 'Places & Moments', prompts: [
    { title: 'A Place That Felt Like Home', hint: 'Not just where you lived \u2014 where you belonged' },
    { title: 'My Happiest Memory', hint: 'The first one that comes to mind' },
    { title: 'A Perfect Day', hint: 'Real or imagined \u2014 what would it look like?' },
    { title: 'Simple Pleasures', hint: 'The little things that bring you joy' },
  ]},
];

export const ST_PROMPTS = [
  { id: 1, text: "What's a meal that takes you back to childhood?", emoji: "\uD83C\uDF7D\uFE0F" },
  { id: 2, text: "How did you meet your spouse or best friend?", emoji: "\uD83D\uDC95" },
  { id: 3, text: "Describe the house you grew up in.", emoji: "\uD83C\uDFE0" },
  { id: 4, text: "What's a story your family always retells?", emoji: "\uD83D\uDE02" },
  { id: 5, text: "What did holidays look like in your family?", emoji: "\uD83C\uDF84" },
  { id: 6, text: "What are you most proud of?", emoji: "\uD83C\uDFC6" },
  { id: 7, text: "What was the day your first child was born like?", emoji: "\uD83D\uDC76" },
  { id: 8, text: "Who was your favorite teacher, and what did they teach you?", emoji: "\uD83D\uDCDA" },
  { id: 9, text: "What was your first job or your first car?", emoji: "\uD83D\uDE97" },
  { id: 10, text: "What's the most beautiful place you've ever been?", emoji: "\uD83C\uDF05" },
];

export const AI_Q_CATEGORIES = [
  'a specific childhood adventure or mischief',
  'a turning point in their career or education',
  'a funny or embarrassing family moment',
  'a lesson learned the hard way',
  'a place that changed how they see the world',
  'a friendship that shaped who they are',
  'something they believed as a kid that turned out to be wrong',
  'a moment of unexpected kindness from a stranger',
  'a tradition they started or wish they had',
  'a risk they took that paid off \u2014 or didn\'t',
  'a sound, smell, or song that instantly transports them',
  'something they\'d tell their younger self',
  'a time they stood up for something or someone',
  'their first big purchase or financial lesson',
  'a holiday or celebration that went hilariously wrong',
  'a secret talent, hobby, or guilty pleasure',
  'a neighbor, coworker, or character from their past',
  'a moment they realized they\'d become their parent',
  'a trip or adventure that didn\'t go as planned',
  'something about the world today that surprises them',
];
